import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { loadWeeklyInformations } from './actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';
import { loadUnpagedGrades } from '../grades/actions';

class WeeklyInformations extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		
		this.loadGrades();
		
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({...filter, sortKey, sortDirection, pageSize, pageNumber});
	}
	
	loadGrades() {
		const { loadUnpagedGrades } = this.props;
		loadUnpagedGrades();
	}
	
	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	render() {
		const { isReadonly, gradesList} = this.props;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} grades={gradesList} loading={this.props.pagination.loading} />
				<List isReadonly={isReadonly} onFetchData={this.handleListEvent} data={this.props.data} {...this.props.pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { weeklyInformations, grades },
		auth: { currentUser }
	} = state;

	const weeklyInformationsPagination = pagination.weeklyInformations.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: weeklyInformationsPagination.ids.map(id => weeklyInformations[id]),
		pagination: weeklyInformationsPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'WeeklyInformations'),
		gradesList: grades
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadWeeklyInformations,
	initializeFilter: (data, fields) => initialize('weeklyInformationsFilter', data, fields),
	loadUnpagedGrades
})(WeeklyInformations);